import { Injectable } from '@angular/core';
import { CacheService } from '@app/shared/services/cache.service';
import { Client } from '@app/shared';

@Injectable()
export class TimezoneService {

  timezones = {};

  constructor(private cache: CacheService,
    private client: Client) {
    this.timezones = JSON.parse(localStorage.getItem('timezones')) || {};
    this.cache.getValue(this.client.getTimezonesUrl).subscribe(res => {
      res.map(el => {
        this.timezones[el.service_id]=el.offset;
      });
      if(res[0])
      localStorage.setItem('timezone', res[0].offset);
      localStorage.setItem('timezones', JSON.stringify(this.timezones));
    });
  }

  toLocTime(order) {
    let offset = this.timezones[order.service_id] * 1000;
    if (order.assigned_at !== null) {
      order.assigned_at = new Date(Date.parse(order.assigned_at) + offset);
    }

    if (order.created_at) {
      order.created_at = new Date(Date.parse(order.created_at) + offset);
    }

    if (order.trip && order.trip.arriving_at) {
      order.trip.arriving_at = new Date(Date.parse(order.trip.arriving_at) + offset);
    }

    if (order.searched_at !== undefined && order.searched_at !== null) {
      order.searched_at = new Date(Date.parse(order.searched_at) + offset);
    }

    if (order.status === 'processing') {
      order.efireTime = ((Date.now() - +new Date(order.created_at)) / 1000 / 60).toFixed(0);
    } else {
      order.efireTime = null;
    }

    return order;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/timezone.service.ts